module.exports = __webpack_public_path__ + "static/media/05.6f5c459e.png";